module.exports = __webpack_public_path__ + "static/img/no-award.894363f5.png";